module.exports = __webpack_public_path__ + "7bfb83236022fc3b042b782b7dd15eef.fbx";